import { useField } from 'formik';
import { Grid } from '@mui/material';

import { InputType } from 'types';
import { getDefaultInputOptions } from 'utils/form';
import { InputField, RadioField, SwitchField } from 'components';

import { inputTypeOptions } from './config';
import { FormInputFieldProps } from './types';

export const FormInputField = ({ name, value }: FormInputFieldProps) => {
  const [, , { setValue }] = useField(name);

  return (
    <div className="flex flex-col gap-4">
      <RadioField
        row
        label="Input type"
        options={inputTypeOptions}
        name={`${name}.options.type`}
        onChange={(event) => {
          const newType = event.target.value as InputType;
          setValue({
            ...value,
            options: {
              ...getDefaultInputOptions(),
              type: newType,
            },
          });
        }}
      />

      {value?.options?.type === InputType.Text && (
        <Grid container spacing={2}>
          <Grid size={{ md: 6, xs: 12 }}>
            <InputField
              fullWidth
              type="number"
              label="Min length"
              placeholder="Min length"
              name={`${name}.options.minLength`}
            />
          </Grid>

          <Grid size={{ md: 6, xs: 12 }}>
            <InputField
              fullWidth
              type="number"
              label="Max length"
              placeholder="Max length"
              name={`${name}.options.maxLength`}
            />
          </Grid>

          <Grid>
            <SwitchField label="Multiline" name={`${name}.options.multiline`} />
          </Grid>
        </Grid>
      )}

      {value?.options?.type === InputType.Number && (
        <Grid container spacing={2}>
          <Grid size={{ md: 6, xs: 12 }}>
            <InputField
              fullWidth
              type="number"
              label="Min value"
              placeholder="Min value"
              name={`${name}.options.minValue`}
            />
          </Grid>

          <Grid size={{ md: 6, xs: 12 }}>
            <InputField
              fullWidth
              type="number"
              label="Max value"
              placeholder="Max value"
              name={`${name}.options.maxValue`}
            />
          </Grid>

          <Grid>
            <SwitchField label="Integer" name={`${name}.options.integer`} />
          </Grid>
        </Grid>
      )}
    </div>
  );
};
